<template>
  <v-layout pa-1 row wrap @mouseover="$emit('hovered')">
    <v-flex d-flex xs2 md1>
      <v-card flat>
        <v-card-text>
          <SnippetImportance
            :currentImportance="getSeverity(question.importance, 'audititem')"
          />
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex xs10 md11 d-flex>
      <v-layout row wrap>
        <v-flex d-flex xs12 md2>
          <v-card color tile flat class="overflow-hidden">
            <v-card-text
              v-if="
                config.preparation.grouped && config.preparation.subcategory
              "
              >{{ question.subcategory }}</v-card-text
            >
            <v-card-text v-else>
              <SnippetCategory
                :category-id="question.category"
                :standard-id="standard"
              />
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex d-flex xs12 md3>
          <v-card-text>
            <span v-if="question.chapters">
              <span
                v-for="(chapter, chapter_index) in question.chapters"
                :key="chapter_index"
              >
                <v-tooltip bottom>
                  <span slot="activator">
                    <v-chip v-if="chapter.standard" label outline
                      >{{ chapter.standard }}: {{ chapter.id }}</v-chip
                    >
                    <v-chip v-else label outline>{{ chapter.id }}</v-chip>
                  </span>
                  <span>{{ chapter.description }}</span>
                </v-tooltip>
              </span>
            </span>
          </v-card-text>
        </v-flex>

        <v-flex d-flex xs12 md7>
          <v-card color tile flat>
            <v-card-text class="pre">{{ question.text }}</v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.pre {
  tab-size: 2;
  -moz-tab-size: 2;
  white-space: pre;
}
</style>
<script>
// Controls/Snippets
import SnippetImportance from "@/components/snippets/Importance.vue";
import SnippetCategory from "@/components/snippets/SnippetCategory";
import { Importance } from "@/datatypes/Importance";

import { mapGetters } from "vuex";
import { api } from "@/store/modules/configuration";

export default {
  props: {
    question: {
      type: Object,
      default() {
        return {};
      }
    },
    standard: {
      type: [Array, String],
      default: ""
    }
  },
  components: {
    SnippetImportance,
    SnippetCategory
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.audititem]),
    config() {
      return this.audititem || {};
    }
  },
  methods: {
    //TODO Merge with AuditExecution
    getSeverity(severity, type) {
      //console.log("Audititem Conf", this.audititem)
      if (type == "audititem") {
        return new Importance(
          this.audititem.data.importance.find(setting => setting.id == severity)
        );
      } /*else if (type == "finding") {
        return this.finding.data.importance.find(setting => setting.id === severity)
      }*/ else {
        return new Importance();
      }
    }
  }
};
</script>
